import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators, FormBuilder, FormControl } from '@angular/forms';
import { OktaService } from '../../../shared/services/okta.service';
import {
  requestActivateFactorPlayload,
  requestEnrollFactorPlayload,
  requestGetUserPayload,
  requestRemoveUserFactorPayload,
} from '../../../shared/models/model';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../../shared/services/authorization.service';
import { FactorType } from '../../../shared/enums/FactorType';
import { Subscription } from 'rxjs';
import config from '../../../../assets/config.json';

@Component({
  selector: 'app-mfaenrollment',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './mfaenrollment.component.html',
  styleUrls: ['./mfaenrollment.component.scss'],
})
export class MFAEnrollmentComponent implements OnInit {
  enrollform: FormGroup = new FormGroup({});
  controlNames = ['email', 'text', 'audio'];
  otpVisible: boolean[] = [false, false, false]; // Track OTP visibility for each field
  verifyBtnVisible: boolean[] = [false, false, false]; // Track verify button visibility for each field
  isFieldInvalid: boolean[] = [false, false, false]; // Track field validity for each field
  IsVerifiedContact: boolean[] = [false, false, false]; // Track if contact is verified for each field
  verifyBtnEnabled = [false, false, false];
  verifyCodeBtnEnabled = [false, false, false];
  hasNoFactorEnroll: boolean = false;
  enrollForm: boolean = false;
  hasNoFactorActived_Ctn_btn: boolean = false;
  isfactorSaved: boolean = false;
  isContinueEnabled: boolean = true;
  // Notification variables
  notificationText: string = '';
  notificationVisible: boolean = false;
  notificationStyle: string = '';
  public num_of_active_factors_counter: number = 0;
  MFALoginKeyName: string = config.MFALoginKeyName;
  MFALoginKey: string = '';
  resendFactorSubscription: Subscription = new Subscription();
  activateFactorSubscription: Subscription = new Subscription();
  enrollFactorSubscription: Subscription = new Subscription();
  removeUserFactorsubscription: Subscription = new Subscription();
  getUserSubscription: Subscription = new Subscription();
  errorMsg_otp_Email_const: string = 'Enter the security code sent to your email';
  errorMsg_Text_SMS_const: string = 'Enter your phone number to get otp via text message';
  errorMsg_Voice_const: string = 'Enter your phone number to get OTP via audio call';

  errorMsg_otp_Email: string = this.errorMsg_otp_Email_const;
  errorMsg_Text_SMS: string = this.errorMsg_Text_SMS_const;
  errorMsg_Voice: string = this.errorMsg_Voice_const;

  errorMsg_otp_Email_res: string = 'Enter the security code sent to your email';
  errorMsg_Text_SMS_res: string = 'Enter the otp sent on your phone number';
  errorMsg_Voice_res: string = 'Enter the otp sent on your phone number via call';

  constructor(
    private _fb: FormBuilder,
    private _okta: OktaService,
    private _router: Router,
    public _authService: AuthorizationService,
  ) {}
  ngOnInit(): void {
    this.enrollform = this._fb.group({
      email: ['', [Validators.required, Validators.email]],
      text: ['', [Validators.required]],
      audio: ['', [Validators.required]],
      otp_Email: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      otp_text_sms: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      otp_audio: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      isChecked: new FormControl({ value: true, disabled: false }),
    });
    this.SelectFactorApi();
  }

  updateCheckboxState(): void {
    const checkboxControl = this.enrollform.get('isChecked');
    if (this.num_of_active_factors_counter < 2) {
      this.IsVerifiedContact.forEach((isVerified, i) => {
        if (isVerified) {
          this.enrollform.get(this.controlNames[i])?.disable(); // Disable the respective control
        }
      });
      checkboxControl?.disable(); // Disable the checkbox
    } else {
      this.controlNames.forEach((name) => {
        this.enrollform.get(name)?.enable(); // Enable all control names
      });
      checkboxControl?.enable(); // Enable the checkbox
    }
  }

  onRemoveUserFactor(event: any, index: number) {
    if (this.num_of_active_factors_counter < 2) {
      this.handleNotifications('checkboxError');
      this.updateCheckboxState();
      event.preventDefault();
      return;
    }

    let factorType: number;
    if (index === 0) {
      factorType = FactorType.Email;
    } else if (index === 1) {
      factorType = FactorType.Phone;
    } else if (index === 2) {
      factorType = FactorType.Audio;
    } else {
      throw new Error('Invalid index');
    }

    const payload: requestRemoveUserFactorPayload = {
      requestingSystem: 'FinPro',
      userName: '',
      factorType: factorType,
    };
    this.removeUserFactorsubscription = this._okta.removeUserFactor(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          this.IsVerifiedContact[index] = false;
          this.clearOtpField(index);
          this.verifyBtnVisible[index] = true;
          this.num_of_active_factors_counter--;
          this.updateCheckboxState();
        }
      },
      error: (e) => {
        this.handleNotifications('apiError', e.error.response);
      },
    });
  }

  SelectFactorApi() {
    const payload: requestGetUserPayload = {
      requestingSystem: 'FinPro',
      browserName: this._okta.getBrowserName(),
      userName: this._authService.getUserId(),
    };
    this.getUserSubscription = this._okta.getUser(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          if (_data?.nextAction === 'Enroll') {
            this.hasNoFactorEnroll = true;
            document.title = 'Enrollment Welcome';
          } else if (_data?.nextAction === 'Challenge' || _data?.nextAction === 'Select') {
            this._router.navigate(['/advisor/mfa/challenge']);
          } else if (_data?.nextAction === 'Bypass') {
            this._router.navigate(['/advisor/idp/bypass-code']);
          } else if (_data?.nextAction === 'InitiateIDP') {
            this._router.navigate(['/user-profile/personal-information']);
          } else if (_data.nextAction === 'Home' && _data.a9b7xk_0q) {
            this.saveMFAToken(_data.a9b7xk_0q);
            this._router.navigate(['/advisor']);
          } else if (_data?.nextAction === 'Home') {
            this.OnContinueBtnClick();
          } else {
            this._router.navigate(['/user-profile/call-us']);
          }
        }
      },
      error: () => {
        this._router.navigate(['/user-profile/call-us']);
      },
    });
  }

  enrollUerFactorApi(index: number, event: Event) {
    const controlName = this.controlNames[index];
    const control = this.enrollform.get(controlName);

    if (!control?.valid) {
      this.updateFieldValidity(index, false);
      return;
    }

    let isValid = false;
    if (controlName === 'email') {
      isValid = this.validateEmail(control.value);
      setTimeout(() => {
        if (isValid) {
          const inputElement = document.querySelector('#securitycodesent');
          if (inputElement) {
            (inputElement as HTMLElement).focus();
            (inputElement as HTMLElement).setAttribute('aria-live', 'assertive');
          }
        }
      }, 100);
    } else if (controlName === 'text' || controlName === 'audio') {
      isValid = this.validatePhoneNumber(control.value);
      if (isValid) {
        this.errorMsg_Text_SMS = this.errorMsg_Text_SMS_const;
        this.errorMsg_Voice = this.errorMsg_Voice_const;
      }
    }

    if (!isValid) {
      this.updateFieldValidity(index, false);
      return;
    }

    const payload = this.createEnrollFactorPayload(index);
    this.toggleVerifyButton(index, true);
    this.enrollFactorSubscription = this._okta.enrollFactorApi(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          this.otpUIVisibility(index);
        }
      },
      error: (e) => {
        this.handleNotifications('apiError', e.error.response);
        this.toggleVerifyButton(index, true);
        setTimeout(() => {
          const clickedElement = event.target;
          const t1 = '.form-group.test01';
          const t2 = '.form-group.test02';
          const t3 = '.form-group.test03';
          let closestDiv = '';
          let prefixedClasses = '';
          if (clickedElement instanceof HTMLElement) {
            closestDiv = clickedElement.closest('div')?.parentElement?.closest('div')?.className || '';
            prefixedClasses = closestDiv
              .split(' ')
              .map((className) => `.${className}`)
              .join('');
          }
          const inputElement = document.querySelector(prefixedClasses + ' input'); // Select the input element
          if (t2 === prefixedClasses && inputElement) {
            (inputElement as HTMLElement).focus();
            this.errorMsg_Text_SMS = e.error.response;
          } else if (t1 === prefixedClasses && inputElement) {
            (inputElement as HTMLElement).focus();
            this.errorMsg_otp_Email = e.error.response;
          } else {
            if (t3 === prefixedClasses && inputElement) {
              (inputElement as HTMLElement).focus();
              this.errorMsg_Voice = e.error.response;
            }
          }
        }, 100);
      },
    });
  }
  createEnrollFactorPayload(index: number): requestEnrollFactorPlayload {
    const controlName = this.controlNames[index];
    const controlValue = this.enrollform.get(controlName)?.value;
    let factorType: number;

    if (controlName === 'email') {
      factorType = FactorType.Email;
    } else if (controlName === 'text') {
      factorType = FactorType.Phone;
    } else if (controlName === 'audio') {
      factorType = FactorType.Audio;
    } else {
      throw new Error('Invalid control name');
    }

    return {
      requestingSystem: 'FinPro',
      factorValue: controlValue,
      factorType: factorType,
    };
  }
  createActivateFactorPayload(index: number): requestActivateFactorPlayload {
    const otpControlNames = ['otp_Email', 'otp_text_sms', 'otp_audio'];
    const controlName = otpControlNames[index];
    const controlValue = this.enrollform.get(controlName)?.value;
    let factorType: number;

    if (controlName === 'otp_Email') {
      factorType = FactorType.Email;
    } else if (controlName === 'otp_text_sms') {
      factorType = FactorType.Phone;
    } else if (controlName === 'otp_audio') {
      factorType = FactorType.Audio;
    } else {
      throw new Error('Invalid control name');
    }

    return {
      requestingSystem: 'FinPro',
      passCode: controlValue,
      browserName: this._okta.getBrowserName(),
      factorType: factorType,
    };
  }

  activateFactorApi(index: number, event: Event) {
    const payload = this.createActivateFactorPayload(index);
    this.toggleCodeVerifyButton(index, true);
    this.activateFactorSubscription = this._okta.activateFactorFactorApi(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          this.IsVerifiedContact[index] = true;
          this.verifyBtnVisible[index] = false;
          this.otpVisible[index] = false;
          this.isContinueEnabled = false;
          this.num_of_active_factors_counter++;
          this.updateCheckboxStateByIndex(index);
          this.updateCheckboxState();
          this.handleNotifications('apiSuccess');
          this.saveMFAToken(_data?.a9b7xk_0q);
        }
      },
      error: (e) => {
        this.handleNotifications('apiError', e.error.response);
        this.toggleCodeVerifyButton(index, false);
        setTimeout(() => {
          const clickedElement = event.target;
          const t1 = '.otp-sent-block.test01';
          const t2 = '.otp-sent-block.test02';
          const t3 = '.otp-sent-block.test03';
          let closestDiv = '';
          let prefixedClasses = '';
          if (clickedElement instanceof HTMLElement) {
            closestDiv = clickedElement.closest('div')?.parentElement?.closest('div')?.className || '';
            prefixedClasses = closestDiv
              .split(' ')
              .map((className) => `.${className}`)
              .join('');
          }
          const inputElement = document.querySelector(prefixedClasses + ' input');
          if (inputElement) {
            (inputElement as HTMLElement).focus();
            if (t1 === prefixedClasses) {
              this.errorMsg_otp_Email_res = e.error.response;
            } else if (t2 === prefixedClasses) {
              this.errorMsg_Text_SMS_res = e.error.response;
            } else {
              if (t3 === prefixedClasses) {
                this.errorMsg_Voice_res = e.error.response;
              }
            }
          }
        }, 100);
      },
    });
  }
  updateCheckboxStateByIndex(index: number): void {
    if (this.IsVerifiedContact[index]) {
      this.enrollform.get('isChecked')?.setValue(true);
    }
  }

  OnContinueBtnClick() {
    if (this._authService.getUrl()) {
      this._router.navigate([this._authService.getUrl()?.path], {
        queryParams: this._authService.getUrl()?.queryParams,
      });
      sessionStorage.removeItem('RequestedURL');
    } else {
      this._router.navigate(['advisor']);
    }
  }
  enableEnrollform() {
    this.enrollForm = true;
    this.hasNoFactorEnroll = false;
    document.title = 'Two-Step Security Setup';
  }

  // Function to handle input field value change
  InputfieldValueChange(event: any, index: number) {
    const controlName = this.controlNames[index];
    this.clearOtpField(index);
    const control = this.enrollform.get(controlName);
    this.toggleVerifyButton(index, false);
    if (index === 0) {
      if (this.validateEmail(control?.value)) {
        this.verifyBtnVisible[index] = true;
      } else {
        this.verifyBtnVisible[index] = false;
        this.IsVerifiedContact[index] = false;
        this.otpVisible[index] = false;
      }
    } else if (this.validatePhoneNumber(control?.value)) {
      this.verifyBtnVisible[index] = true;
      this.otpVisible[index] = false;
    } else {
      this.otpVisible[index] = false;
      this.verifyBtnVisible[index] = false;
      this.isFieldInvalid[index] = false;
      this.IsVerifiedContact[index] = false;
    }
  }

  // Validate email address
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.com$/;
    const valid = emailRegex.test(email);
    return valid;
  }

  // Validate phone number
  validatePhoneNumber(phoneNumber: string): boolean {
    const phoneRegex = /^(?:\+1)?\d{10}$/;
    const valid = phoneRegex.test(phoneNumber);
    return valid;
  }

  // Function to handle the OTP window visibility
  otpUIVisibility(index: number): void {
    const controlName = this.controlNames[index];
    const control = this.enrollform.get(controlName);
    if (control?.valid) {
      let isValid = false;
      if (controlName === 'email') {
        isValid = this.validateEmail(control.value);
      } else if (controlName === 'text' || controlName === 'audio') {
        isValid = this.validatePhoneNumber(control.value);
      }

      this.updateFieldValidity(index, isValid);
    } else {
      this.otpVisible[index] = false;
      this.verifyBtnVisible[index] = false;
    }
  }

  // Function to update field validity and visibility
  updateFieldValidity(index: number, isValid: boolean): void {
    if (isValid) {
      this.otpVisible[index] = true;
      this.verifyBtnVisible[index] = false;
      this.isFieldInvalid[index] = false;
    } else {
      this.isFieldInvalid[index] = true;
      this.verifyBtnVisible[index] = true;
    }
  }

  // // Function to get if the input field is valid
  isValidControl(controlName: string): boolean {
    return this.enrollform.get(controlName)?.valid ?? false;
  }

  //resend factor otp to check
  resendFactor(index: number) {
    const payload = this.createEnrollFactorPayload(index);
    this.resendFactorSubscription = this._okta.resendFactor(payload)?.subscribe({
      next: (_data) => {
        if (_data) {
          this.clearOtpField(index);
        }
      },
      error: (e) => {
        this.handleNotifications('apiError', e.error.response);
      },
    });
  }

  //function to clear otp field
  clearOtpField(index: number) {
    if (index === 0) {
      this.enrollform.get('otp_Email')?.setValue('');
    } else if (index === 1) {
      this.enrollform.get('otp_text_sms')?.setValue('');
    } else if (index === 2) {
      this.enrollform.get('otp_audio')?.setValue('');
    }
  }

  // Function to show notification
  showNotification(text: string, style: string) {
    this.notificationText = text;
    this.notificationStyle = style;
    this.notificationVisible = true;
    setTimeout(() => {
      this.notificationVisible = false; // Hide notification after 6 seconds
    }, 6000); // 6000 ms = 6 seconds
  }

  // Example function to handle different notifications
  handleNotifications(_notificationType: string, _errorMsg?: string) {
    if (_notificationType === 'checkboxError') {
      this.showNotification('You must have at least one factor.', 'error');
    } else if (_notificationType === 'apiSuccess') {
      this.showNotification('Your factor has been saved.', 'success');
    } else if (_notificationType === 'apiError') {
      this.showNotification(_errorMsg || 'Something went wrong. Your request was not fulfilled.', 'error');
    } else {
      this.notificationVisible = false;
    }
  }

  toggleVerifyButton(index: number, isEnabled: boolean): void {
    this.verifyBtnEnabled[index] = isEnabled;
  }

  toggleCodeVerifyButton(index: number, isEnabled: boolean): void {
    this.verifyCodeBtnEnabled[index] = isEnabled;
  }

  saveMFAToken(token: string): void {
    const date = new Date(Date.now() + Number(config.idleAppMfaTimeOut)); // Set expiration date using config.idleAppMfaTimeOut
    const expires = 'expires=' + date.toUTCString(); // Convert the date to UTC string
    const encodedToken = btoa(token); // Base64 encode the token to ensure it's safely stored
    // Set the cookie with the 'Secure' and 'Path' attributes
    document.cookie = `${this.MFALoginKeyName}=${encodedToken}; ${expires}; path=/; Secure;`;
  }
}
